import { render, staticRenderFns } from "./ModalKardex.vue?vue&type=template&id=5c372947&scoped=true"
import script from "./ModalKardex.vue?vue&type=script&lang=js"
export * from "./ModalKardex.vue?vue&type=script&lang=js"
import style0 from "./ModalKardex.vue?vue&type=style&index=0&id=5c372947&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c372947",
  null
  
)

export default component.exports